export { default } from './leasing-waiting-item';
